import { useEffect, useState } from "react";
import {
   fetchSalesIndividualPerformance,
   SalesIndividualFilterParams,
   PerformanceOverviewResponse,
} from "../services/salesIndividualDashboardApi";

interface SalesIndividualPerformanceState {
  data: PerformanceOverviewResponse | null;
  isLoading: boolean;
  error: string | null;
}

const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error) return error.message;
  return "Failed to load Sales Performance.";
};

export const useSalesIndividualPerformance = (
  filters: SalesIndividualFilterParams,
  enabled: boolean,
  refreshKey = 0,
): SalesIndividualPerformanceState => {
  const [state, setState] = useState<SalesIndividualPerformanceState>({
    data: null,
    isLoading: false,
    error: null,
  });

  useEffect(() => {
    if (!enabled) return;
    if (filters.period === "custom" && (!filters.from_date || !filters.to_date)) {
      return;
    }

    let isCurrent = true;

    setState((current) => ({
      ...current,
      isLoading: true,
      error: null,
    }));

    fetchSalesIndividualPerformance(filters)
      .then((data) => {
        if (!isCurrent) return;
        setState({ data, isLoading: false, error: null });
      })
      .catch((error) => {
        if (!isCurrent) return;
        setState((current) => ({
          ...current,
          isLoading: false,
          error: getErrorMessage(error),
        }));
      });

    return () => {
      isCurrent = false;
    };
  }, [enabled, filters.period, filters.from_date, filters.to_date, refreshKey]);

  return state;
};
